import { ApiPath } from "enums";
import { Get } from "utils";

export const getShifts = async (query) => {
  const res = await Get(`${ApiPath.ShiftRecords}`, query);
  return res.data;
};
